import { MenuItem, TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { investmentStatusLabelMap } from '@/features/investments/util.ts';
import { handledInvestmentTypes, investmentTypeLabels } from '@/features/investments/constants.ts';
import FormSection from '@/features/investments/form/components/FormSection.tsx';
import {
  InvestmentFormData,
  investmentStatusOptions,
} from '@/features/investments/form/investment-form.schema.ts';

const StateSection = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<InvestmentFormData>();

  return (
    <FormSection title="2. Estado" description="Situación actual de la inversión.">
      <Controller
        name="status"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            select
            label="Estado de la inversión"
            fullWidth
            error={!!errors.status}
            helperText={errors.status?.message}
          >
            {investmentStatusOptions.map((status) => (
              <MenuItem key={status} value={status}>
                {investmentStatusLabelMap[status]}
              </MenuItem>
            ))}
          </TextField>
        )}
      />

      <Controller
        name="type"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            select
            label="Estrategia"
            fullWidth
            error={!!errors.type}
            helperText={errors.type?.message}
          >
            {handledInvestmentTypes.map((investmentType) => (
              <MenuItem key={investmentType} value={investmentType}>
                {investmentTypeLabels[investmentType]}
              </MenuItem>
            ))}
          </TextField>
        )}
      />
    </FormSection>
  );
};

export default StateSection;
